import { Box, Typography } from '@mui/material';
import React from 'react';

export const MatchingPropLeadFieldTextShow = ({ property }) => {
  const { label, publicLabel, value, type } = property;

  return (
    <Box className="flex items-start justify-between gap-2">
      <Typography>{`${publicLabel || label}: `}</Typography>
      <Typography>{`${value || '-'}`}</Typography>
    </Box>
  );
};
